import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u800726540/domains/noventilabs.com/hbuilds/source/repository/src/app/services/[slug]/ServiceDetailClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u800726540/domains/noventilabs.com/hbuilds/source/repository/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u800726540/domains/noventilabs.com/hbuilds/source/repository/src/components/Header.tsx");
